import { useEffect } from "react";
import { Platform } from "react-native";

import * as ImagePicker from "expo-image-picker";

const useMedia = () => {
    //PROMPT USER FOR PERMISSION TO ACCESS CAMERA / MEDIA LIBRARY
    useEffect(() => {
        (async () => {
            if (Platform.OS !== "web") {
                const { status } = await ImagePicker.requestMediaLibraryPermissionsAsync();
                if (status !== "granted") {
                    return;
                }
            }
        })();
        (async () => {
            if (Platform.OS !== "web") {
                const { status } = await ImagePicker.requestCameraPermissionsAsync();
                if (status !== "granted") {
                    return;
                }
            }
        })();
    }, []);

    const selectImageFromLibrary = async () => {
        let result = await ImagePicker.launchImageLibraryAsync({
            mediaTypes: ImagePicker.MediaTypeOptions.All,
            quality: 0.2,
        });

        if (!result.cancelled) {
            return result.uri;
        } else {
            return false;
        }
    };

    const selectImageFromCamera = async () => {
        let result = await ImagePicker.launchCameraAsync({
            mediaTypes: ImagePicker.MediaTypeOptions.All,
            quality: 0.2,
        });

        console.log(result);
        if (!result.cancelled) {
            return result.uri;
        } else {
            return false;
        }
    };

    return { selectImageFromCamera, selectImageFromLibrary };
};

export default useMedia;
